import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-cookies',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './cookies.component.html',
  styleUrl: './cookies.component.scss'
})
export class CookiesComponent {
  showCookies = false;

  constructor() {
    localStorage.getItem('cookies') ? this.showCookies = false : this.showCookies = true;
  }

  ngAfterViewInit() {
  }

  acceptCookies() {
    this.showCookies = false;
    localStorage.setItem('cookies', 'true');
  }
}
